import type { SanitySocialProof } from '#/lib/sanity/queries/socialProof';

import { RatingStarsSocialProof } from './RatingStars';

export function SocialProof({
  socialProof,
}: {
  socialProof: SanitySocialProof;
}) {
  if (!socialProof || socialProof.length === 0 || socialProof.length > 1) {
    return null;
  }
  return (
    <div className="bg-grayscale-01 rounded-10 p-16 mt-20 mb-40">
      <RatingStarsSocialProof {...socialProof[0]} />
    </div>
  );
}
